import React, { useEffect, useState } from 'react';
import { inquilinosService, documentosService, API_BASE } from '../services/api';
import Documentos from '../components/Documentos';

const FORM_VACIO = {
  tipo: 'persona_fisica', nombre: '', apellido: '', documento: '',
  email: '', telefono: '', telefono_alternativo: '', nacionalidad: 'Uruguaya',
  fecha_nacimiento: '', direccion_anterior: '', notas: ''
};

export default function Inquilinos() {
  const [inquilinos, setInquilinos] = useState([]);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [detalle, setDetalle] = useState(null);
  const [contratosDetalle, setContratosDetalle] = useState([]);
  const [docsContratos, setDocsContratos] = useState({}); // { contrato_id: [docs] }
  const [form, setForm] = useState(FORM_VACIO);
  const [busqueda, setBusqueda] = useState('');
  const [vistaLista, setVistaLista] = useState(true);

  const cargar = () => inquilinosService.getAll().then(r => setInquilinos(r.data));
  useEffect(() => { cargar(); }, []);

  const abrirDetalle = async (inq) => {
    setDetalle(inq);
    setDocsContratos({});
    const res = await inquilinosService.getById(inq.id);
    const contratos = res.data.contratos || [];
    setContratosDetalle(contratos);
    // cargar documentos de cada contrato
    const docs = {};
    await Promise.all(contratos.map(async c => {
      const r = await documentosService.getByEntidad('contrato', c.id);
      docs[c.id] = r.data;
    }));
    setDocsContratos(docs);
  };

  const abrirNuevo = () => {
    setEditando(null);
    setForm(FORM_VACIO);
    setModal(true);
  };

  const abrirEditar = (inq) => {
    setEditando(inq.id);
    setForm({
      tipo: inq.tipo || 'persona_fisica',
      nombre: inq.nombre || '',
      apellido: inq.apellido || '',
      documento: inq.documento || '',
      email: inq.email || '',
      telefono: inq.telefono || '',
      telefono_alternativo: inq.telefono_alternativo || '',
      nacionalidad: inq.nacionalidad || '',
      fecha_nacimiento: inq.fecha_nacimiento ? inq.fecha_nacimiento.split('T')[0] : '',
      direccion_anterior: inq.direccion_anterior || '',
      notas: inq.notas || '',
    });
    setModal(true);
  };

  const cerrarModal = () => { setModal(false); setEditando(null); setForm(FORM_VACIO); };

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    if (editando) {
      await inquilinosService.update(editando, form);
      // refrescar detalle si está abierto
      if (detalle?.id === editando) {
        const res = await inquilinosService.getById(editando);
        setDetalle(res.data);
        setContratosDetalle(res.data.contratos || []);
      }
    } else {
      await inquilinosService.create(form);
    }
    cerrarModal();
    cargar();
  };

  const inquilinosFiltrados = inquilinos.filter(i =>
    `${i.nombre} ${i.apellido} ${i.documento} ${i.email}`.toLowerCase().includes(busqueda.toLowerCase())
  );

  return (
    <div>
      <div className="page-header">
        <h1>Inquilinos</h1>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <div className="view-toggle">
            <button className={!vistaLista ? 'active' : ''} onClick={() => setVistaLista(false)} title="Vista tarjetas">▦ Tarjetas</button>
            <button className={vistaLista ? 'active' : ''} onClick={() => setVistaLista(true)} title="Vista lista">☰ Lista</button>
          </div>
          <button className="btn btn-primary" onClick={abrirNuevo}>+ Nuevo inquilino</button>
        </div>
      </div>

      {/* Buscador */}
      <div style={{ marginBottom: 20 }}>
        <input
          placeholder="🔍 Buscar por nombre, documento o email..."
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
          style={{ width: '100%', maxWidth: 400 }}
        />
      </div>

      {inquilinosFiltrados.length === 0 ? (
        <div className="empty-state">
          <h3>{busqueda ? 'Sin resultados' : 'No hay inquilinos cargados'}</h3>
          <p>{busqueda ? 'Probá con otro término' : 'Hacé clic en "Nuevo inquilino" para agregar el primero'}</p>
        </div>
      ) : vistaLista ? (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Nombre</th>
                <th>CI / RUT</th>
                <th>Email</th>
                <th>Teléfono</th>
                <th>Inmueble alquilando</th>
                <th>Tipo</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {inquilinosFiltrados.map(i => (
                <tr key={i.id} style={{ cursor: 'pointer' }} onClick={() => abrirDetalle(i)}>
                  <td><strong>{i.nombre} {i.apellido}</strong></td>
                  <td>{i.documento || '-'}</td>
                  <td>{i.email || '-'}</td>
                  <td>{i.telefono || '-'}</td>
                  <td>
                    {i.inmueble_activo
                      ? <span style={{ color: '#27ae60', fontWeight: 600, fontSize: '0.85rem' }}>🏠 {i.inmueble_activo}</span>
                      : <span style={{ color: '#aaa', fontSize: '0.85rem' }}>—</span>}
                  </td>
                  <td>{i.tipo === 'empresa' ? 'Empresa' : 'Persona'}</td>
                  <td onClick={e => e.stopPropagation()}>
                    <button className="btn btn-secondary"
                      style={{ fontSize: '0.78rem', padding: '5px 12px' }}
                      onClick={() => abrirEditar(i)}>
                      ✏️ Editar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="cards-grid">
          {inquilinosFiltrados.map(i => (
            <div key={i.id} className="card" style={{ borderLeft: '5px solid #4f8ef7', cursor: 'pointer' }} onClick={() => abrirDetalle(i)}>
              <div className="card-header">
                <h3>{i.nombre} {i.apellido}</h3>
                <span style={{ fontSize: '0.72rem', padding: '3px 10px', borderRadius: 20, fontWeight: 600, background: i.tipo === 'empresa' ? '#f5eeff' : '#eaf2ff', color: i.tipo === 'empresa' ? '#9b59b6' : '#4f8ef7' }}>
                  {i.tipo === 'empresa' ? 'Empresa' : 'Persona'}
                </span>
              </div>
              {i.documento && <p>🪪 {i.documento}</p>}
              {i.email && <p>📧 {i.email}</p>}
              {i.telefono && <p>📱 {i.telefono}</p>}
              {i.inmueble_activo
                ? <p style={{ color: '#27ae60', fontWeight: 600, fontSize: '0.85rem', marginTop: 6 }}>🏠 {i.inmueble_activo}</p>
                : <p style={{ color: '#aaa', fontSize: '0.85rem', marginTop: 6 }}>Sin inmueble activo</p>}
              <div style={{ display: 'flex', gap: 8, marginTop: 14 }} onClick={e => e.stopPropagation()}>
                <button className="btn btn-secondary" style={{ flex: 1, padding: '7px 0', fontSize: '0.82rem' }} onClick={() => abrirDetalle(i)}>📁 Ver ficha</button>
                <button className="btn btn-secondary" style={{ padding: '7px 12px', fontSize: '0.82rem' }} onClick={() => abrirEditar(i)}>✏️</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* MODAL DETALLE INQUILINO */}
      {detalle && (
        <div className="modal-overlay" onClick={() => setDetalle(null)}>
          <div className="modal" style={{ width: 700 }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
              <div>
                <h2 style={{ marginBottom: 4 }}>{detalle.nombre} {detalle.apellido}</h2>
                <span style={{ fontSize: '0.8rem', color: '#888' }}>
                  {detalle.tipo === 'empresa' ? 'Empresa' : 'Persona física'}
                  {detalle.nacionalidad ? ` · ${detalle.nacionalidad}` : ''}
                </span>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-secondary" style={{ fontSize: '0.82rem' }}
                  onClick={() => { setDetalle(null); abrirEditar(detalle); }}>
                  ✏️ Editar
                </button>
                <button className="btn btn-secondary" style={{ fontSize: '0.82rem' }}
                  onClick={() => setDetalle(null)}>
                  ✕ Cerrar
                </button>
              </div>
            </div>

            {/* Datos personales */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 24px', fontSize: '0.88rem', color: '#555', marginBottom: 16 }}>
              {detalle.documento && <p>🪪 CI/RUT: <strong>{detalle.documento}</strong></p>}
              {detalle.email && <p>📧 <a href={`mailto:${detalle.email}`} style={{ color: '#4f8ef7' }}>{detalle.email}</a></p>}
              {detalle.telefono && <p>📱 {detalle.telefono}</p>}
              {detalle.telefono_alternativo && <p>📞 {detalle.telefono_alternativo}</p>}
              {detalle.fecha_nacimiento && <p>🎂 {new Date(detalle.fecha_nacimiento).toLocaleDateString('es-UY')}</p>}
              {detalle.direccion_anterior && <p>📍 {detalle.direccion_anterior}</p>}
            </div>

            {detalle.notas && (
              <div style={{ background: '#f8f9fa', borderRadius: 8, padding: '10px 14px', fontSize: '0.85rem', color: '#666', marginBottom: 16 }}>
                📝 {detalle.notas}
              </div>
            )}

            {/* Contratos */}
            {contratosDetalle.length > 0 && (
              <>
                <hr style={{ border: 'none', borderTop: '1px solid #f0f0f0', margin: '16px 0' }} />
                <h3 style={{ fontSize: '0.95rem', color: '#1a1a2e', marginBottom: 12 }}>Contratos</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {contratosDetalle.map(c => (
                    <div key={c.id} style={{ background: '#f8f9fa', borderRadius: 8, padding: '10px 14px', fontSize: '0.86rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <strong>{c.inmueble_nombre}</strong>
                        <span style={{ marginLeft: 8, color: '#888' }}>{c.direccion}</span>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontWeight: 700, color: '#1a1a2e' }}>{c.moneda} {parseFloat(c.monto).toLocaleString()}/mes</div>
                        <div style={{ fontSize: '0.78rem', color: '#aaa' }}>
                          {new Date(c.fecha_inicio).toLocaleDateString('es-UY')} → {c.fecha_fin ? new Date(c.fecha_fin).toLocaleDateString('es-UY') : '∞'}
                        </div>
                        <span style={{
                          fontSize: '0.72rem', padding: '2px 8px', borderRadius: 20, fontWeight: 600,
                          background: c.estado === 'activo' ? '#eafaf1' : '#f0f0f0',
                          color: c.estado === 'activo' ? '#27ae60' : '#95a5a6'
                        }}>{c.estado}</span>
                        {/* Documentos del contrato */}
                        {docsContratos[c.id]?.length > 0 && (
                          <div style={{ marginTop: 6, display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'flex-end' }}>
                            {docsContratos[c.id].map(doc => (
                              <a key={doc.id}
                                href={`${API_BASE}${doc.archivo_url}`}
                                target="_blank" rel="noreferrer"
                                style={{ fontSize: '0.78rem', color: '#4f8ef7', textDecoration: 'none' }}
                                onClick={e => e.stopPropagation()}>
                                📄 {doc.nombre}
                              </a>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* Documentos */}
            <hr style={{ border: 'none', borderTop: '1px solid #f0f0f0', margin: '16px 0' }} />
            <Documentos entidadTipo="inquilino" entidadId={detalle.id} />
          </div>
        </div>
      )}

      {/* MODAL FORMULARIO */}
      {modal && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>{editando ? 'Editar inquilino' : 'Nuevo inquilino'}</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group full">
                  <label>Tipo</label>
                  <select name="tipo" value={form.tipo} onChange={handleChange}>
                    <option value="persona_fisica">Persona física</option>
                    <option value="empresa">Empresa</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Nombre *</label>
                  <input name="nombre" value={form.nombre} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <label>Apellido</label>
                  <input name="apellido" value={form.apellido} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>CI / RUT</label>
                  <input name="documento" value={form.documento} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Nacionalidad</label>
                  <input name="nacionalidad" value={form.nacionalidad} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input name="email" type="email" value={form.email} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Teléfono</label>
                  <input name="telefono" value={form.telefono} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Teléfono alternativo</label>
                  <input name="telefono_alternativo" value={form.telefono_alternativo} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Fecha de nacimiento</label>
                  <input name="fecha_nacimiento" type="date" value={form.fecha_nacimiento} onChange={handleChange} />
                </div>
                <div className="form-group full">
                  <label>Dirección anterior</label>
                  <input name="direccion_anterior" value={form.direccion_anterior} onChange={handleChange} placeholder="Domicilio previo al contrato" />
                </div>
                <div className="form-group full">
                  <label>Notas</label>
                  <textarea name="notas" value={form.notas} onChange={handleChange} rows={3} />
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={cerrarModal}>Cancelar</button>
                <button type="submit" className="btn btn-primary">{editando ? 'Guardar cambios' : 'Guardar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
